import { Injectable } from '@angular/core';
import { IIntelligentSecurityShell } from 'src/app/data-models/smart-assist/intelligent-security-shell.interface';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { VantageShellService } from 'src/app/services/vantage-shell/vantage-shell.service';

@Injectable({
	providedIn: 'root',
})
export class IntelligentSecurityService {
	private intelligentSensing: IIntelligentSecurityShell;

	constructor(private logger: LoggerService, private vantageShellService: VantageShellService) {
		this.intelligentSensing = vantageShellService.getIntelligentSensing();
	}

	public async isAvailable(): Promise<boolean> {
		try {
			const isIntelligentSecurityCapable = await this.intelligentSensing.GetHPDCapability();
			this.logger.info(
				'intelligentSecurityService Capability --------------',
				isIntelligentSecurityCapable
			);

			return isIntelligentSecurityCapable;
		} catch (error) {
			this.logger.error('setDefaultHPDLeaveSensitivity: ', error);
		}
	}

	public async getHPDLeaveSensitivityVisibility(): Promise<boolean> {
		return await this.intelligentSensing.GetHPDLeaveSensitivityVisibility();
	}

	public setHPDStatus(value: boolean): Promise<boolean> {
		// HPD global switch status. true means enable, false means disable
		const option = value ? 'True' : 'False';
		return this.intelligentSensing.SetHPDGlobalSetting(option);
	}

	public setZeroTouchLoginStatus(value: boolean): Promise<boolean> {
		// HPD global switch status. true means enable, false means disable
		const option = value ? 'True' : 'False';
		return this.intelligentSensing.SetHPDApproachSetting(option);
	}

	public setZeroTouchLoginAdjustStatus(value: boolean): Promise<boolean> {
		// HPD global switch status. true means enable, false means disable
		const option = value ? 'True' : 'False';
		return this.intelligentSensing.SetHPDAutoAdjustSetting(option);
	}

	/**
	 * Get currently selected lock screen timer value
	 * 1 = Near,
	 * 2 = Middle/Medium,
	 * 3 = Far
	 */
	public setZeroTouchLoginDistance(value: number): Promise<boolean> {
		// HPD global switch status. true means enable, false means disable
		const option = value.toString();
		return this.intelligentSensing.SetHPDApproachDistanceSetting(option);
	}

	// set auto adjust for IdeaPad models
	public setZeroTouchLockStatus(value: boolean): Promise<boolean> {
		const option = value ? 'True' : 'False';
		return this.intelligentSensing.SetHPDPresentLeaveSetting(option);
	}

	/**
	 * Get currently selected lock screen timer value
	 * '1' = Fast
	 * '2' = Medium
	 * '3' = Slow
	 */
	public setSelectedLockTimer(value: string): Promise<boolean> {
		return this.intelligentSensing.SetHPDLeaveWaitSetting(value);
	}

	public setAutoScreenTimeoutStatus(value: boolean): Promise<boolean> {
		return this.intelligentSensing.SetHPDPresentSetting(value);
	}

	// Set HPDLeave Sensitivity Setting
	public SetHPDLeaveSensitivitySetting(value: number): Promise<boolean> {
		return this.intelligentSensing.SetHPDLeaveSensitivitySetting(value);
	}
	public setHPDATSetting(value: boolean): Promise<boolean> {
		return this.intelligentSensing.SetHPDATSetting(value);
	}
	/**
	 * Get currently selected lock screen timer value
	 * '1' = Fast
	 * '2' = Medium
	 * '3' = Slow
	 */
	public setHPDATTimer(value: number): Promise<boolean> {
		const option = value.toString();
		return this.intelligentSensing.SetHPDATTimer(option);
	}
	/**
	 * Based on the display brightness setting in Windows settings,
	 * your screen brightness will be further reduced to the percentage
	 * you set below.
	 * 'XX' → XX% (decimal)
	 */
	public setHPDDimTarget(value: number): Promise<boolean> {
		const option = value.toFixed(0).toString();
		return this.intelligentSensing.SetHPDDimTarget(option);
	}

	public setHPDATinAC(value: boolean): Promise<boolean> {
		return this.intelligentSensing.SetHPDATinAC(value);
	}

	public getATSetting(): Promise<number> {
		return this.intelligentSensing.GetATSetting();
	}
}
